<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <h1 class="headline font-weight-light">
                    Onsite Pending
                </h1>
            </v-col>
        </v-row>
        <v-row class="mt-4">
            <v-col cols="12" sm="4">
                <v-select
                    :items="data_branch"
                    label="Select Zone"
                    item-text="branch_name"
                    item-value="branch_id"
                    menu-props="auto"
                    v-model="branch"
                    outlined
                    dense
                    hide-details
                    @change="get_data()"
                ></v-select>
            </v-col>
        </v-row>
        <v-row class="no-pd mar-t-10">
            <v-col cols="12" v-if="data_agging_case.length != 0">
                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center" rowspan="2">
                                    Status
                                </th>
                                <th
                                    class="text-center"
                                    :colspan="
                                        data_agging_case.agging_group.length + 1
                                    "
                                >
                                    Case Agging
                                </th>
                            </tr>
                            <tr class="col-tr-1">
                                <th
                                    class="text-center"
                                    v-for="(row2,
                                    index2) in data_agging_case.agging_group"
                                    :key="index2"
                                >
                                    {{ row2 }}
                                </th>
                            </tr>
                        </thead>
                        <tbody
                            v-for="(r2, i2) in data_agging_case.summary"
                            :key="i2"
                        >
                            <tr class="bg-tr-1">
                                <td
                                    :colspan="
                                        data_agging_case.agging_group.length + 1
                                    "
                                >
                                    <b>{{ r2.project_name }}</b>
                                </td>
                            </tr>
                            <tr v-for="(r22, i22) in r2.status" :key="i22">
                                <td>{{ r22.status_name }}</td>
                                <td
                                    v-for="(r222, i222) in r22.agging"
                                    :key="i222"
                                    class="text-right"
                                >
                                    <div
                                        :style="'color:' + colorx[i222]"
                                        :class="
                                            r222.num_cases > 0
                                                ? 'fix-td-1 cur-p'
                                                : 'fix-td-1'
                                        "
                                        @click="
                                            change_agging(
                                                i222,
                                                r22.status_name,
                                                r2.project_name,
                                                r222.num_cases
                                            )
                                        "
                                    >
                                        {{ r222.num_cases }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close_dialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <!-- <v-toolbar-title>Settings</v-toolbar-title> -->
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <table-view-case
                                    :condition="condition"
                                    :data_case="detail_agging_case"
                                    :casetab="casetab"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import TableViewCase from "../../Project/components/TableViewCase"
let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: {
        "table-view-case": TableViewCase,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_branch()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async get_branch() {
            this.mutateIsLoading()
            await axios
                .get(url + "engineer/pending/tl-get-zone", this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.data_branch = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data() {
            let send = {
                branch: this.branch,
            }
            this.mutateIsLoading()
            await axios
                .post(url + "engineer/pending/tl-get-case", send, this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.data_agging_case = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async change_agging(data1, data2, data3, num) {
            if (num > 0) {
                let send = {
                    case_status: data2,
                    project_name: data3,
                    agging: this.convert_data(data1),
                    branch: this.branch,
                }

                await axios
                    .post(
                        url + "engineer/pending/tl-get-case-detail",
                        send,
                        this.tk
                    )
                    .then((response) => {
                        this.casetab = true
                        this.detail_agging_case = response
                    })
                    .catch((error) => {
                        console.log(error)
                        return false
                    })
                this.dialog = true
            }
        },
        close_dialog() {
            this.casetab = false
            this.dialog = false
        },
        convert_data(data) {
            if (data == 0) {
                return "0"
            } else if (data == 1) {
                return "1"
            }
            if (data == 2) {
                return "2-3"
            }
            if (data == 3) {
                return "4-7"
            }
            if (data == 4) {
                return "8-14"
            }
            if (data == 5) {
                return "15-29"
            }
            if (data == 6) {
                return "30+"
            }
            if (data == 7) {
                return "total"
            }
        },
    },
    data() {
        return {
            data_agging_case: [],
            data_branch: [],
            detail_agging_case: [],
            branch: "",
            tk: null,
            dialog: false,
            casetab: false,
            condition: {
                team: localStorage.team_name,
                status: "ViewDetail",
            },
            colorx: [
                "rgb(0, 82, 0)",
                "rgb(13, 97, 13)",
                "rgb(32, 126, 32)",
                "rgb(252, 187, 66)",
                "rgb(245, 118, 33)",
                "rgb(245, 75, 33)",
                "rgb(214, 43, 0)",
            ],
        }
    },
}
</script>
<style scoped>
.bg-tr-1 {
    background-color: rgb(217, 233, 247) !important;
}
.fix-td-1 {
    font-weight: bold !important;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
    background-color: rgb(92, 157, 253);
    color: #fff !important;
}
</style>
